import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import i18n from '../i18n';

// Function to detect browser language and map to supported languages
const detectBrowserLanguage = () => {
  // Get browser language (first 2 chars for language code)
  const browserLang = navigator.language.split('-')[0];
  
  // Check if browser language is supported in our app
  const supportedLanguages = ['en', 'it', 'de', 'fr', 'ja', 'ko', 'es'];
  return supportedLanguages.includes(browserLang) ? browserLang : 'en';
};

// Check if language is already in localStorage
const getInitialLanguage = () => {
  try {
    // Try to get from localStorage first
    const persistedState = localStorage.getItem('language-storage');
    if (persistedState) {
      const { state } = JSON.parse(persistedState);
      if (state && state.language) {
        console.log('Found language in localStorage:', state.language);
        return state.language;
      }
    }
    
    // If not in localStorage, detect from browser
    const browserLang = detectBrowserLanguage();
    console.log('Detected browser language:', browserLang);
    return browserLang;
  } catch (e) {
    console.error('Error getting initial language:', e);
    return 'en'; // Fallback to English on error
  }
};

const useLanguageStore = create(
  persist(
    (set) => ({
      language: getInitialLanguage(),
      setLanguage: (language) => {
        i18n.changeLanguage(language);
        set({ language });
      },
    }),
    {
      name: 'language-storage', // unique name for localStorage
      getStorage: () => localStorage, // use localStorage
    }
  )
);

export default useLanguageStore;